import { PayloadAction } from '@reduxjs/toolkit';
import { isFormDirty } from '@ui/features/quote-builder/state/selectors/quote-builder-dirty';
import { stringifyQuote } from '@ui/features/quote-builder/state/utilities/stringify-quote';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { QuoteLineType } from '../../types/state/quote-line';

export function quoteLineCreatedOptimistic(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{ quoteLine: QuoteLineType }>,
) {
  const { quoteLine } = action.payload;

  const wasFormDirty = isFormDirty(state);

  state.quoteLineUuids.splice(quoteLine.lineNumber - 1, 0, quoteLine.uuid);
  state.quoteLines[quoteLine.uuid] = quoteLine;

  if (!wasFormDirty) {
    state.pendingServerData = stringifyQuote(state);
  }
}
